import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  GET_POINT,
  GET_TOTAL_POINT,
  GET_USER_ADMIN,
  GET_USER_INFO,
} from "../querykeys";
import { request } from "../api";
import { BaseResponse } from "../types/baseRespones";
import { User } from "src/types/User";

/* 유저정보 가져오기 */
export const useUserRegister = () => {
  return useQuery({
    queryKey: [GET_USER_INFO],
    queryFn: async () => {
      const result = await request<BaseResponse<User>>({
        method: "GET",
        url: "/users/me",
      });
      return result.response;
    },
  });
};

export const useAllUserRegister = () => {
  return useQuery({
    queryKey: [GET_USER_ADMIN],
    queryFn: async () => {
      const result = await request<BaseResponse<User[]>>({
        method: "GET",
        url: "/users/all",
      });
      return result.response;
    },
  });
};

//point logs
export const usePointLogsRegister = () => {
  return useQuery({
    queryKey: [GET_POINT],
    queryFn: async () => {
      const result = await request<BaseResponse<any>>({
        method: "GET",
        url: `/point/logs`,
      });
      return result.response || [];
    },
  });
};

export const usePointRegister = () => {
  return useQuery({
    queryKey: [GET_POINT],
    queryFn: async () => {
      const result = await request<BaseResponse<any>>({
        method: "GET",
        url: `/point`,
      });
      return result.response || [];
    },
  });
};

/* 전체 포인트 */
export const useTotalPointRegister = () => {
  return useQuery({
    queryKey: [GET_TOTAL_POINT],
    queryFn: async () => {
      const result = await request<any>({
        method: "GET",
        url: `/point/total`,
      });
      return result || [];
    },
  });
};

/* 유저정보 업데이트 */
export const useUpdateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (inputs: any) => {
      return request<BaseResponse>({
        method: "PUT",
        url: `/users/me`,
        data: inputs,
      });
    },
    onSuccess: (res: BaseResponse) => {
      queryClient.invalidateQueries({ queryKey: [GET_USER_INFO] });
    },
  });
};

/* 유저 탈퇴하기 */
export const useDeleteUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return request<BaseResponse>({
        method: "DELETE",
        url: `/users/me`,
      });
    },
    onSuccess: (res: BaseResponse) => {
      queryClient.invalidateQueries({ queryKey: [GET_USER_INFO] });
    },
  });
};
